export const NAV = [
  { label: "Who We Are", href: "/who-we-are", route: true },
  { label: "Creative Team", href: "#featured" },
  { label: "Events", href: "#events" },
  { label: "Opportunity", href: "#opportunity" },
  { label: "Venues", href: "#venues" },
  { label: "Contact", href: "#contact" },
];

export const DARWIN = {
  name: "Darwin Paiva",
  role: "Artist Designer",
  body: "Darwin shapes the visual identity and creative direction behind CANARTS artists and events, giving every project its own distinct look and feel.",
  image:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_event-showcase-117/artifacts/zug87eaq_ChatGPT%20Image%20Aug%2013%2C%202026%2C%2012_36_24%20PM.png",
};

export const FEATURED_ARTIST = {
  name: "Andres Quintanilla",
  tagline: "Creative Director & Executive Producer",
  handle: "@mr_quintanilla.a",
  instagram: "https://www.instagram.com/mr_quintanilla.a",
  headline: "The Creative Team",
  body: "Andres Quintanilla is a Toronto-based Nicaraguan creative director, producer and artist developer. His role at CANARTS extends beyond the studio — guiding projects from the initial idea and artistic vision through development and production.",
  body2: "Working alongside artists, producers and engineers, he helps connect the creative and technical sides of each project while keeping the artist's identity at the center of the process.",
  musical: "His musical journey began at 12 — evolving from rock to acoustic, emotionally driven production and composition.",
  tags: ["Nicaraguan", "Toronto-based", "Producer", "Artist Developer", "Director"],
  image:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_event-showcase-117/artifacts/rqdli1d5_A52FB7DB-E68B-4F01-B7BC-269B24A24F25.png",
};

export const FOUNDER = {
  name: "Efrain Garcia",
  role: "Founder & CEO · Canarts Music",
  body: "Efrain Garcia is one of the founders of Canarts Music, building the company alongside his business partner Darwin. Together they drive the vision, the sound and the experiences behind every Canarts stage.",
  image:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_event-showcase-117/artifacts/cvye0odk_2B4C0318-B397-4BB9-BE0A-2B100F34226A.png",
};

export const MANIFESTO = [
  {
    n: "01",
    title: "Beyond the show",
    body: "We want to evolve live experiences into new feelings — richer, deeper, better ways to live an event.",
  },
  {
    n: "02",
    title: "A different kind of feeling",
    body: "Not just a concert. A sensation designed to move you and stay with you long after the lights go down.",
  },
  {
    n: "03",
    title: "You have to live it",
    body: "Some things can't be explained. You simply have to be there — and feel it — to truly know.",
  },
];

export const EVENTS = [
  {
    id: "ev1",
    artist: "To Be Revealed",
    category: "Artists + DJs",
    date: "Coming Soon",
    venue: "Location to be announced",
    variant: "dj",
    span: "large",
    image:
      "https://static.prod-images.emergentagent.com/jobs/6a664c28-eef0-4071-b9bd-fa39e14e218b/images/7c7b2e585486f066d5fff8b1d896eb2b2da4ca1562fe3fa188dcf24a94f40f09.jpeg",
  },
  {
    id: "ev2",
    artist: "To Be Revealed",
    category: "Artists + DJs",
    date: "Coming Soon",
    venue: "Location to be announced",
    variant: "brand",
    span: "small",
  },
  {
    id: "ev3",
    artist: "To Be Revealed",
    category: "Artists + DJs",
    date: "Coming Soon",
    venue: "Location to be announced",
    variant: "brand",
    span: "small",
  },
  {
    id: "ev4",
    artist: "To Be Revealed",
    category: "Artists + DJs",
    date: "Coming Soon",
    venue: "Location to be announced",
    variant: "brand",
    span: "large",
  },
];

export const OPPORTUNITY = [
  { title: "Real Stages", desc: "Selected artists perform at Canarts events in front of live Toronto audiences." },
  { title: "Artist Development", desc: "Honest feedback and coaching through a 12-month growth process with our team." },
  { title: "A Team Behind You", desc: "Production, sound, visuals and promotion handled by professionals." },
  { title: "Long-Term Vision", desc: "We build artist careers together — not one-night moments." },
];

export const ARTISTS = [
  {
    name: "Chimbala",
    role: "Headliner",
    image:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_event-showcase-117/artifacts/62yxoven_image.png",
  },
  {
    name: "Kai Montero",
    role: "Guitar & Vocals",
    image:
      "https://images.unsplash.com/photo-1595422656857-ced3a4a0ce25?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    name: "Luna Sáez",
    role: "Soul Singer",
    image:
      "https://images.unsplash.com/photo-1526218626217-dc65a29bb444?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    name: "Dario Vela",
    role: "DJ Set",
    image:
      "https://images.unsplash.com/photo-1576967402682-19976eb930f2?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
];

export const COLLABS = [
  {
    name: "DUAVA",
    genre: "Pop · R&B",
    note: "Sri Lankan-Canadian singer",
    instagram: "https://www.instagram.com/duava/",
    image:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_event-showcase-117/artifacts/621eacbb_image.png",
  },
  {
    name: "Xav Trudeau",
    genre: "R&B · Melodic",
    note: "Canadian R&B artist",
    instagram: "https://www.instagram.com/xavtrudeau_/",
    image:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_event-showcase-117/artifacts/qj3qcdg7_image.png",
  },
  {
    name: "Andres Quintanilla",
    genre: "Producer · Artist Developer",
    note: "Toronto-based Nicaraguan creative",
    instagram: "https://www.instagram.com/mr_quintanilla.a",
    image:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_event-showcase-117/artifacts/rqdli1d5_A52FB7DB-E68B-4F01-B7BC-269B24A24F25.png",
  },
];

export const VENUES = [
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_event-showcase-117/artifacts/clp1letv_IMG_7382.webp",
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_event-showcase-117/artifacts/izjhrq22_IMG_7383.webp",
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_event-showcase-117/artifacts/kckyavhw_IMG_7384.JPG",
];

export const HERO_IMAGE =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_event-showcase-117/artifacts/9yi9amk4_artist%20at%20stage%20canarts%20.png";

const A = "https://customer-assets-lxgj4vgw.emergentagent.net/job_event-showcase-117/artifacts";
export const STUDIO = {
  hero: `${A}/y0zdek32_image.png`,
  banner: `${A}/uwojxyse_Screenshot%202026-08-13%20115308.png`,
  images: [`${A}/gs8rpc76_image.png`, `${A}/6l3qnnkb_image.png`],
};
